import { render, staticRenderFns } from "./HomePageCard.vue?vue&type=template&id=328ec240&scoped=true"
import script from "./HomePageCard.vue?vue&type=script&lang=js"
export * from "./HomePageCard.vue?vue&type=script&lang=js"
import style0 from "./HomePageCard.vue?vue&type=style&index=0&id=328ec240&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328ec240",
  null
  
)

export default component.exports